<div class="dropdown">
  <button class="btn btn-outline-primary btn-sm" style="padding-right: 10px; font-weight: 700;" type="button" id="dropdownMenu2" data-bs-toggle="dropdown" aria-expanded="false">
    {{defaultSelection}} &nbsp; <i class="material-icons-outlined" style="font-size: larger; position: relative;top: 4px;">expand_more</i>
  </button>
  <ul class="dropdown-menu" aria-labelledby="dropdownMenu2">
    @for (item of dropList; track $index) {
      <li><button class="dropdown-item" type="button" (click)="this.selectElement.emit(item)">{{item.label}}</button></li>
    }
  </ul>
</div>
